import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import {mapActions, mapState} from 'vuex'
// import dateUtils from '../../../../common/utils/dateUtil'
import moment from 'moment'

export default {
  data () {
    return {
      typeName: '全部',
      pageNum: 1,
      pageSize: 10,
      pageOrder: 'desc',
      pageSort: 'id',
      centerHeight: document.documentElement.clientHeight - 180 +'px'
    }
  },
  computed: {
    ...mapState('exchangeRecordModule', ['exchangeRecordList']),
    exchangeRecordListInfo () {
      return this.exchangeRecordList
    }
  },
  methods: {
    ...mapActions('exchangeRecordModule', ['getExchangeRecord']),
    generateUrl (content) {
      this.qrCode = `//${location.host}/api/qr/generate?content=${content}&X-Authorization=${localStorage.getItem('token')}`
    },
    goBack (item) {
      this.$router.push({
        path: RoutePathConstants.WX_PERSONAL_CENTER,
        query: {
        }
      })
    },
    dateFormat (time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    getExchangeRecordInfo () {
      let code = ''
      if (this.typeName == '已领取') {
        code = '2000'
      } else if (this.typeName == '未领取') {
        code = '1000'
      }
      let pageData = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        pageSort: this.pageSort,
        pageOrder: this.pageOrder,
        orderStatus: code
      }
      this.getExchangeRecord(pageData)
    },
    load () {
      this.pageSize +=10
      this.getExchangeRecordInfo()
    }
  },
  mounted () {
    // this.$router.query.ON_USE_STATUS_UNWRITTEN
    this.getExchangeRecordInfo()
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/exchange-record/views/exchange-record.js